// extracted by mini-css-extract-plugin
module.exports = {"card":"Stats_card__oN8XJ","sortBy":"Stats_sortBy__qRKC2","label":"Stats_label__PFt4p","button":"Stats_button__x2Ch7","icon":"Stats_icon__ynrYY"};